/* tslint:disable */
declare global {
	interface Window {
		MigrosTokenProvider: any;
	}
}
/* tslint:enable */

export async function getAuthTokenWeb(onRecieveToken: (token: string) => void) {
	const accessTokenObject = await window.MigrosTokenProvider.getAccessToken();
	onRecieveToken(accessTokenObject.token);
}
